import styled from "styled-components"

export const FeatureImageWrapper = styled.div`
    grid-colum: 3/ span 10;
`